import { render } from "./DocumentReportProcessed.vue?vue&type=template&id=20abe6a3&scoped=true&ts=true"
import script from "./DocumentReportProcessed.vue?vue&type=script&lang=ts"
export * from "./DocumentReportProcessed.vue?vue&type=script&lang=ts"

import "./DocumentReportProcessed.vue?vue&type=style&index=0&id=20abe6a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20abe6a3"]])

export default __exports__